<template>
<div class="regionView">
  <PageTopForm>
    <div slot="form">
      <el-form-item label="区域名称：">
        <el-input v-model="formInline.searchText" placeholder="请输入" :maxlength="20" show-word-limit clearable @keyup.enter.native.prevent="onSubmit"></el-input>
      </el-form-item>
      <div class="search-btn">
        <!-- <span @click="onSubmit">查询</span>
        <span class="line"></span>
        <span @click="reset">重置</span> -->
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="default" @click="reset">重置</el-button>
      </div>
    </div>
  </PageTopForm>
  <div class="topButtons">
    <el-button type="primary" icon="el-icon-document-add" @click="openAddRegion" :disabled="permissionLevel <= PermissionLevel.LOOKER">新建</el-button>
  </div>
  <!-- <el-table
    :data="tableData"
    style="width: 100%;margin-bottom: 20px;"
    row-key="id"
    ref="regionTable"
    default-expand-all
    :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
    <el-table-column prop="name" label="名称" width="180">
      <template slot-scope="scope">
        <div>
          <Icon type="big" name="el-icon-service"></Icon>
          {{ scope.row.name }}
        </div>
      </template>
    </el-table-column>
    <el-table-column prop="date" label="日期" width="180"></el-table-column>
    <el-table-column prop="address" label="地址" ></el-table-column>
  </el-table> -->
  <dragTreeTable class="ragion-table" ref="dragTreeTable" :data="treeData"  :onDrag="onTreeDataChange" :beforeDragOver="beforeDragOver" @click.native="clickTable" :isdraggable="permissionLevel >= PermissionLevel.COMPILER"></dragTreeTable>
  <div class="empty" v-show="treeData.lists.length<=0">
    <Empty></Empty>
  </div>
  <RegionAttribute ref="regionAttribute" @refresh="refreshTable"></RegionAttribute>
</div>
</template>

<script>
import dragTreeTable from 'drag-tree-table'
import PageTopForm from '@/components/PageTopForm/PageTopForm'
import RegionAttribute from './Components/RegionAttribute.vue'
import { getArealList, delArea, moveArea, getArea, sortArea } from '@/api/area'
import { searchBFS, treeForeach } from '@/utils/tree'
import { PermissionLevel } from '@/configs/constants'
import { mapGetters } from 'vuex'
export default {
  name: 'Region',
  props: {},
  components: { PageTopForm, RegionAttribute, dragTreeTable },
  data () {
    return {
      tileTypeOptions: [
        { title: '二维影像', type: 1 },
        { title: '三维模型', type: 2 }
      ],
      formInline: {
        searchText: '',
        type: undefined
      },

      columns: [
        {
          prop: 'name',
          label: '模型名称',
          width: '200'
        },
        {
          prop: 'type',
          label: '模型类型',
          custom: true
        },
        {
          prop: 'level',
          label: '数据精度',
          width: '200'
        },
        {
          prop: 'time',
          label: '上传时间',
          width: '200'
        }
      ],
      treeData: {
        lists: [],
        custom_field: {
          id: 'id',
          // order: 'sort',
          lists: 'children',
          parent_id: 'parentId'
        },
        columns: [
          {
            title: '区域名称',
            field: 'name',
            type: 'selection',
            width: 894,
            align: 'left',
            formatter: (item) => {
              if (item.type === 'COMMON') {
                return '<svg width="1em" height="1em"aria-hidden="true" style="margin-right:5px;position: relative; top:2px"><use xlink:href="#icon-quyu1"></use></svg>' + item.name
              } else {
                return '<svg width="1em" height="1em"aria-hidden="true" style="margin-right:5px;position: relative; top:2px"><use xlink:href="#icon-moxingyingyong1"></use></svg>' + item.name
              }
            }
          },
          {
            title: '创建时间',
            field: 'createTime',
            width: 435,
            align: 'left',
            formatter: (item) => {
              return new Date(item.createTime).format('yyyy/MM/dd hh:mm:ss')
            }
          },
          {
            title: '备注',
            field: 'remark',
            align: 'left',
            width: 435,
            formatter: (item) => {
              return `<span title=${item.remark ?? ''}>${item.remark ?? ''}</span>`
            }
          },
          {
            title: '操作',
            type: 'action',
            width: 90,
            align: 'left',
            actions: [
              {
                text: '编辑',
                onclick: (item) => {
                  if (this.permissionLevel <= PermissionLevel.LOOKER) {
                    return
                  }
                  this.onEdit(item)
                },
                formatter: (item) => {
                  if (this.permissionLevel <= PermissionLevel.LOOKER) {
                    return '<div title="编辑" class="action-icon disabled"><svg width="1em" height="1em"aria-hidden="true" fill="currentColor"><use xlink:href="#icon-edit"></use></svg></div>'
                  }
                  return '<div title="编辑" class="action-icon"><svg width="1em" height="1em"aria-hidden="true" fill="currentColor"><use xlink:href="#icon-edit"></use></svg></div>'
                }
              },
              {
                text: '删除',
                onclick: (item) => {
                  if (this.permissionLevel <= PermissionLevel.LOOKER) {
                    return
                  }
                  this.onDel(item)
                },
                formatter: (item) => {
                  if (this.permissionLevel <= PermissionLevel.LOOKER) {
                    return '<div title="删除" class="action-icon disabled"><svg width="1em" height="1em"aria-hidden="true" fill="currentColor"><use xlink:href="#icon-ashbin"></use></svg></div>'
                  }
                  return '<div title="删除" class="action-icon"><svg width="1em" height="1em"aria-hidden="true" fill="currentColor"><use xlink:href="#icon-ashbin"></use></svg></div>'
                }
              }
            ]
          }
        ]
      },
      reginData: [],
      movedTree: undefined,
      highlightId: undefined,
      PermissionLevel
    }
  },
  computed: {
    ...mapGetters(['permissionLevel'])
  },
  watch: {
    data (newValue, oldValue) {

    }
  },
  mounted () {
    this.loadRegionData()
  },
  methods: {
    onSubmit () {
      if (!this.formInline.searchText) {
        // return this.treeData.lists
        this.treeData.lists = this.reginData
      } else {
        let searchData = searchBFS(this.reginData, 'children', (item) => {
          return item.name.indexOf(this.formInline.searchText) >= 0
        })
        searchData = JSON.parse(JSON.stringify(searchData))
        for (let i = 0; i < searchData.length; i++) {
          searchData[i].children = undefined
        }
        this.treeData.lists = searchData
      }
    },
    reset () {
      this.formInline = this.$options.data().formInline
      this.treeData.lists = this.reginData
    },
    // 加载更多数据
    loadRegionData () {
      getArealList().then(res => {
        // 保存树展开信息
        let oldData
        if (this.reginData && this.reginData.length > 0) {
          oldData = JSON.parse(JSON.stringify(this.reginData))
        }
        this.reginData = res.data
        if (oldData) {
          const self = this
          treeForeach(this.reginData, 'children', (item) => {
            const node = self.getNodeById(item.id)
            if (node && node.open !== undefined) {
              item.open = node.open
            }
          })
        }
        this.treeData.lists = this.reginData
        if (this.movedTree) {
          this.$refs.dragTreeTable.OpenAll(this.movedTree.parentId)
          this.$refs.dragTreeTable.HighlightRow(this.movedTree.id)
          this.highlightId = this.movedTree.id
          this.movedTree = undefined
        }
      })
    },
    // 添加
    openAddRegion () {
      this.$refs.regionAttribute.open()
    },
    // 通过id获取node
    getNodeById (id) {
      const node = searchBFS(this.treeData.lists, 'children', (item) => {
        return item.id === id
      })
      return node[0]
    },
    // 删除
    removeRegion (id) {
      delArea({
        ids: id
      }).then(res => {
        if (res.code === 200) {
          this.$Message('success', '删除成功!')
          this.refreshTable()
        }
      })
    },
    // 拖拽移动
    async onTreeDataChange (newList, curDragItem, toItem, where) {
      // this.treeData.lists = lists
      let id
      let parentId
      const oldNode = this.getNodeById(curDragItem.id)
      if (oldNode.parentId !== curDragItem.parentId) {
        id = curDragItem.id
        parentId = curDragItem.parentId
      }
      if (id !== undefined && parentId !== undefined) {
        await moveArea({
          id: id,
          parentId: parentId
        })
      }
      // 区域排序
      const orderList = {}
      treeForeach(newList, 'children', (item) => {
        orderList[item.id] = item.order
      })
      const orders = Object.keys(orderList).map((key) => {
        return {
          id: key,
          order: orderList[key]
        }
      })
      await sortArea({
        orders
      })
      // 刷新
      this.movedTree = {
        id: id,
        parentId: parentId
      }
      this.refreshTable()
    },
    beforeDragOver (from, to, where) {
      if (where === 'center' && to.type === 'FINAL') {
        return false
      } else {
        return true
      }
    },
    refreshTable () {
      this.loadRegionData()
    },
    onDel (item) {
      getArea({
        id: item.id
      }).then(res => {
        if (res.code === 200) {
          this.$Delete({
            message: res.data.modelId ? '该区域已绑定模型，你确认要删除吗？' : '你确定删除该数据吗？',
            confirm: () => {
              this.removeRegion([item.id])
            },
            cancel: () => {
            }
          })
        }
      })
    },
    onEdit (item) {
      this.$refs.regionAttribute.open(item.id)
    },
    clickTable () {
      this.$refs.dragTreeTable.HighlightRow(this.highlightId, false)
      this.highlightId = undefined
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.regionView{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  color: #ffffff;
  padding: 20px 32px 0px 32px;
  .empty {
    width: 100%;
    height: 200px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 0 0 6px 6px;
    margin-top: -20px;
    img{
      // margin-top: 20px;
    }
  }
  .search-btn{
    margin-left: -10px;
  }
  .buttons{
    text-align: left;
    margin-bottom: 20px;
  }
  // .ragion-table{
  //   max-height: 680px;
  //   overflow-y: auto;
  //   border-radius: 7px;
  // }
  .action-icon{
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    line-height: 10px;
    cursor: pointer;
    box-sizing: border-box;
    transition: all 0.2s;
    text-align: center;
    &.disabled{
      background-color: unset !important;
      cursor: not-allowed !important;
      svg {
        color: #ccc !important;
      }
    }
    &:hover{
      background-color: rgba(255, 255, 255, 0.1);
    }
    svg {
      color: #ccc;
      margin: 3px;
      position: relative;
      top:2px;
      &:hover{
        color: $hover-color;
      }
    }
  }
}
</style>
